document.addEventListener('DOMContentLoaded', async function () {
  const list  = window.WHWishlist ? window.WHWishlist.getList() : [];
  const grid  = document.getElementById('wh-grid');
  const empty = document.getElementById('wh-empty');
  const countEl = document.getElementById('wh-count');
  const header = document.querySelector('.wh-page-header');
  const EC2_URL = 'https://apps.whisperinghomes.com';
  const CID = window.__st && window.__st.cid;

function updateCount() {
  const c = grid.children.length;
  countEl.textContent = c + ' ITEM' + (c !== 1 ? 'S' : '');

  const banner = document.getElementById('wh-login-banner');

  if (c === 0) {
    empty.style.display = 'block';
    grid.style.display = 'none';

    // Hide header when wishlist is empty
    if (header) header.style.display = 'none';

    // Hide login banner
    if (banner) banner.style.display = 'none';

  } else {
    empty.style.display = 'none';
    grid.style.display = 'grid';

    // Show header when wishlist has items
    if (header) header.style.display = 'flex';

    // Show login banner
    if (banner) banner.style.display = 'block';
  }
}

  window.WHMoveToCart = function(el) {
    const variantId = el.getAttribute('data-variant-id');
    const handle = el.getAttribute('data-handle');
    if (!variantId) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
    .then(r => r.json())
    .then(item => {
      if (item.id) {
        let newList = window.WHWishlist.getList().filter(h => h !== handle);
        window.WHWishlist.saveList(newList);
        if (CID) {
          fetch(`${EC2_URL}/wishlist/save`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ customer_id: CID, list: newList })
          }).catch(function() {});
        }
        el.closest('.wh-page-card').remove();
        updateCount();
        if (window.WHWishlist) {
          window.WHWishlist.initAll();
          window.WHWishlist.syncHeaderIcon();
        }
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && item.sections) {
          cartDrawer.classList.remove('is-empty');
          var drawerInner = cartDrawer.querySelector('.drawer__inner');
          if (drawerInner) drawerInner.classList.remove('is-empty');
          cartDrawer.renderContents(item);
        }
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          document.querySelectorAll('.cart-count-bubble').forEach(function(el) {
            el.style.display = cart.item_count > 0 ? '' : 'none';
          });
        });
        if (window.showPopup) window.showPopup(item);
      }
    }).catch(function() {});
  };

  if (!list.length) { empty.style.display = 'block'; updateCount(); return; }

  for (const handle of list) {
    try {
      const res  = await fetch(`/products/${handle}.js`);
      if (!res.ok) continue;
      const prod = await res.json();
      const variant = prod.variants[0];
        const fmt = function(cents) {
        var amount = Math.round(cents / 100);
        var formatted = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return '₹' + formatted;
        };
      const price = fmt(prod.price);
      const comparePrice = prod.compare_at_price && prod.compare_at_price > prod.price
        ? fmt(prod.compare_at_price) : null;

      const card = document.createElement('div');
      card.className = 'wh-page-card';
      card.dataset.handle = handle;
      card.innerHTML = `
        <div class="wh-page-card__img-wrap">
          <a href="/products/${prod.handle}">
            <img src="${prod.featured_image}" alt="${prod.title}" loading="lazy" width="100%" height="100%" />
          </a>
          <button class="wh-page-card__remove" data-handle="${prod.handle}" title="Remove">✕</button>
        </div>
        <div class="wh-page-card__info">
          <a href="/products/${prod.handle}" style="text-decoration:none; color:inherit;">
            <p class="wh-page-card__title">${prod.title}</p>
            <p class="wh-page-card__price">
              ${comparePrice ? `<span class="wh-page-card__price--compare">${comparePrice}</span>` : ''}
              ${price}
            </p>
          </a>
        </div>
        ${prod.available
          ? `<a href="javascript:void(0);" class="wh-page-card__atc" data-variant-id="${variant.id}" data-handle="${prod.handle}" onclick="event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation(); window.WHMoveToCart(this); return false;">Move to Cart</a>`
          : `<span class="wh-page-card__atc wh-page-card__atc--soldout">Sold Out</span>`
        }
      `;
      grid.appendChild(card);
    } catch (e) { console.warn('WH Wishlist: product not found', handle); }
  }

  updateCount();

  grid.addEventListener('click', function (e) {
    const btn = e.target.closest('.wh-page-card__remove');
    if (!btn) return;
    const handle = btn.dataset.handle;
    let newList = window.WHWishlist.getList().filter(h => h !== handle);
    window.WHWishlist.saveList(newList);
    if (CID) {
      fetch(`${EC2_URL}/wishlist/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: CID, list: newList })
      }).catch(function() {});
    }
    btn.closest('.wh-page-card').remove();
    updateCount();
  });

  document.getElementById('wh-clear-all').addEventListener('click', function () {
    window.WHWishlist.saveList([]);
    if (CID) {
      fetch(`${EC2_URL}/wishlist/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: CID, list: [] })
      }).catch(function() {});
    }
    grid.innerHTML = '';
    updateCount();
  });
});

// ── Wishlist page: swap icon + hide count ─────────────────
  if (document.getElementById('wh-wishlist-page')) {
    const wishlistIcons = document.querySelectorAll('a[href*="/pages/wishlist"] img, .wishlist-icon img, #wishlist-icon img');
    
    // Try common Shopify header wishlist icon selectors
    const allLinks = document.querySelectorAll('a[href*="wishlist"]');
    allLinks.forEach(function(link) {
      // Swap any img inside
      const img = link.querySelector('img');
      if (img) {
        img.src = 'https://cdn.shopify.com/s/files/1/0803/6358/5775/files/Wishlist_2.svg';
        img.style.cssText = 'width:22px; height:22px;';
      }
    if (document.getElementById('wh-wishlist-page')) {
        setTimeout(function() {
            const countBubble = document.getElementById('wh-header-count');
            if (countBubble) countBubble.style.display = 'none';
        }, 500);
    }
    });
  }